<template>
    <div id="header" v-if="isSettingLoading === false">
      <div id="header-left" :style="{ background: getSchemaColor() }">
        <h1 id="title-reichraming" >{{settingData[0].title }}</h1>
      </div>
      <div id="logo">
        <img src="/images/logo_reichraming.webp" id="logo-reichraming">
      </div>
      <div id="header-right" :style="{ background: getSchemaColor() }">
        <div id="dateContainer" :style="{ background: getSchemaColor() }">
          <span id="currentTime">{{ this.formatedTime }} Uhr</span>
          <span id="currentDate">{{ this.formatedDate }}</span>
          <!--<span id="last-update">Stand: {{this.formatedDate}}, {{this.formatedTime}}</span>-->
        </div>
      </div>
    </div>
    <div id="content">
      <div id="left-side" v-if="this.isEventLoading === false && this.isSettingLoading === false">
        <template v-for="(event, index) in this.eventData" :key="index">
          <EventCard :eventData="event" :settingData="this.settingData[0]"/>
          <!-- Conditionally render the separator line for all except the last entry -->
          <div v-if="index < this.eventData.length - 1" id="seperator-line-horizontally"></div>
        </template>
      </div>
      <div id="right-side" >
        <div id="news" :style="{ flexDirection: this.displayVertically ? 'row' : 'column' }"
             v-if="this.isNewsLoading === false && isSettingLoading === false">
          <NewsComp :newsData="this.newsData[0]" :displayVertically="this.displayVertically" :settingData="this.settingData[0]"/>
        </div>
        <div id="services" v-if="isDoctorLoading === false && isInseratLoading === false && isExtraLoading === false && isHousingLoading === false && isSettingLoading === false">
          <ServiceComp :doctorData="this.doctorData[0]" :inseratData="this.inseratData" :extraData="this.extraData" :settingData="this.settingData[0]" :housingData="this.housingData[0]"/>
        </div>
      </div>
    </div>
</template>

<script>
import EventCard from './components/EventCard.vue';
import ServiceComp from './components/ServiceComp.vue';
import NewsComp from "./components/NewsComp.vue";

export default {
  components: {
    EventCard,
    ServiceComp,
    NewsComp,
  },
  data() {
    return {
      eventData: null,
      newsData: null,
      doctorData: null,
      inseratData: null,
      extraData: null,
      housingData: null,
      settingData: null,
      formatedDate: null,
      formatedTime: null,
      isNewsLoading: true,
      isEventLoading: true,
      intervalID: null,
      displayVertically: true,
      isDoctorLoading: true,
      isInseratLoading: true,
      isExtraLoading: true,
      isSettingLoading: true,
      isHousingLoading: true,
    };
  },
  created() {
    this.fetchEventData();
    this.updateDateTime();
    this.fetchNewsData();
    this.fetchDoctorData();
    this.fetchInserateData()
    this.fetchExtraData();
    this.fetchSettingData();
    this.fetchHousingData();

    // Update time every second
    this.intervalId = setInterval(() => {
      this.updateDateTime();
    }, 1000);

    // Reload page every 5 min
    setInterval(() => {
      window.location.reload();
    }, 180000); // 5 min
  },
  unmounted() {
    // Clear the interval when the component is destroyed
    clearInterval(this.intervalId);

  },
  methods: {
    fetchEventData() {
      this.isEventLoading = true;
      fetch(`https://infoboard.samc.at/veranstaltungen`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            this.eventData = data;
          })
          .catch((error) => {
            console.error('Error fetching event data:', error);
            this.error = 'Daten konnten nicht geladen werden, versuchen Sie es später nochmal';
          })
          .finally(() => {
            this.isEventLoading = false;
          });
    },
    fetchNewsData() {
      this.isNewsLoading = true;
      fetch(`https://infoboard.samc.at/news`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            this.newsData = data;
            if (this.newsData && this.newsData.length > 0) {
              if ((this.newsData[0].title1 === '' && this.newsData[0].info1 === '') || (this.newsData[0].title2 === '' && this.newsData[0].info2 === '')){
                this.displayVertically = true;
              }
              else if (this.newsData[0].field_vertikal === '1') {
                this.displayVertically = true;
              } else {
                this.displayVertically = false
              }
            }
          })
          .catch((error) => {
            console.error('Error fetching event data:', error);
            this.error = 'Daten konnten nicht geladen werden, versuchen Sie es später nochmal';
          })
          .finally(() => {
            this.isNewsLoading = false;
          });
    },
    fetchDoctorData(){
      this.isDoctorLoading = true;
      fetch(`https://infoboard.samc.at/arztdaten`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            this.doctorData = data;
          })
          .catch((error) => {
            console.error('Error fetching event data:', error);
            this.error = 'Daten konnten nicht geladen werden, versuchen Sie es später nochmal';
          })
          .finally(() => {
            this.isDoctorLoading = false;
          });
    },
    fetchInserateData(){
      this.isInseratLoading = true;
      fetch(`https://infoboard.samc.at/inserate`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            this.inseratData = data;
          })
          .catch((error) => {
            console.error('Error fetching event data:', error);
            this.error = 'Daten konnten nicht geladen werden, versuchen Sie es später nochmal';
          })
          .finally(() => {
            this.isInseratLoading = false;
          });
    },
    fetchHousingData(){
      this.isHousingLoading = true;
      fetch(`https://infoboard.samc.at/unterkuenfte`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            this.housingData = data;
          })
          .catch((error) => {
            console.error('Error fetching event data:', error);
            this.error = 'Daten konnten nicht geladen werden, versuchen Sie es später nochmal';
          })
          .finally(() => {
            this.isHousingLoading = false;
          });
    },
    fetchExtraData(){
      this.isExtraLoading = true;
      fetch(`https://infoboard.samc.at/zusatzinfo`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            this.extraData = data;
            console.log(this.extraData)
          })
          .catch((error) => {
            console.error('Error fetching event data:', error);
            this.error = 'Daten konnten nicht geladen werden, versuchen Sie es später nochmal';
          })
          .finally(() => {
            this.isExtraLoading = false;
          });
    },
    fetchSettingData(){
      this.isSettingLoading = true;
      fetch(`https://infoboard.samc.at/einstellungen`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            this.settingData = data;
            console.log(this.settingData)
          })
          .catch((error) => {
            console.error('Error fetching event data:', error);
            this.error = 'Daten konnten nicht geladen werden, versuchen Sie es später nochmal';
          })
          .finally(() => {
            this.isSettingLoading = false;
          });
    },
    updateDateTime() {
      var now = new Date();

      // Format date as "1 Dezember 2023"
      var optionsDate = {day: 'numeric', month: 'long', year: 'numeric'};
      this.formatedDate = now.toLocaleDateString('de-DE', optionsDate);

      // Format time as "hh:mm"
      var optionsTime = {hour: '2-digit', minute: '2-digit'};
      this.formatedTime = now.toLocaleTimeString('de-DE', optionsTime);

    },
    getSchemaColor() {
      return this.settingData[0].schema === 'blau' ? '#0799cc' : '#5ba885';
    },
  }
}
</script>
<style>
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: Arial;
  align-items: center;
  box-sizing: border-box;

}

#header {
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#header-left {
  width: 42.5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

#header-right {
  width: 42.5%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

#dateContainer {
  font-size: 1.5vw;
  color: #ffffff;
  margin-right: 2%;
  display: flex;
  flex-direction: column;
  align-self: flex-end;
}

#logo {
  width: 15%;
  height: 100%;
  background-color: #ffffff; /* Blue */
  display: flex;
  align-self: center;
  justify-content: center;
}

#content {
  justify-content: center;
  display: flex;
  height: 90%;
  width: 100%;
}

#left-side {
  width: 50%;
  margin: 0.5%;
  margin-right: 0.25%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0.1vh 0.3vh rgba(0, 0, 0, 0.1);
  border-radius: 1vh;
  background-color: #fff;
}

#right-side {
  width: 50%;
  margin: 0.5%;
  margin-left: 0.25%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

#news {
  height: 58%;
  margin-bottom: 1%;
  width: 99%;
  display: flex;
  box-shadow: 0 0.1vh 0.3vh rgba(0, 0, 0, 0.1);
  border-radius: 1vh;
  background-color: #fff;
}

#services {
  height: 41%;
  width: 99%;
  display: flex;
  box-shadow: 0 0.1vh 0.3vh rgba(0, 0, 0, 0.1);
  border-radius: 1vh;
  background-color: #fff;
}

#logo-reichraming {
  padding-left: 1%;
  padding-top: 0.5%;
  padding-bottom: 1%;
  height: 100%;

}

#title-reichraming {
  color: #ffffff; /*#0799cc*/
  margin-left: 2%;
  font-size: 2.5vw;
  align-self: flex-start;
}

#currentDate {
  display: flex;
  flex-direction: row;
  font-size: 1.1vw;
  color: #ffffff;
}

#currentTime {
  display: flex;
  flex-direction: row;
  font-size: 1.4vw;
  color: #ffffff;
}

#seperator-line-horizontally {
  background-color: #ccc;
  width: 100%;
  height: 0.1vh;
  align-self: center;
}

/* #0799cc blue */

</style>
